import { ProductBrand } from './product-brand';

export class Product {
  id: number;
  name: string;
  countryCode: string;
  productBrandId?: number;
  productBrand?: ProductBrand;
}
